import { defineMessages } from "react-intl";

export const columnsMessages = defineMessages({
  code: {
    defaultMessage: "Code",
    id: "h2vipu",
  },
  usage: {
    defaultMessage: "Usage",
    id: "wbsq7O",
  },
  status: {
    defaultMessage: "Status",
    id: "tzMNF3",
  },
});

export const messages = defineMessages({
  empty: {
    defaultMessage: "No voucher codes found",
    id: "KkufwD",
  },
  draft: {
    id: "W6nwjo",
    defaultMessage: "Draft",
  },
  active: {
    id: "3a5wL8",
    defaultMessage: "Active",
  },
  inactive: {
    id: "6Tps09",
    defaultMessage: "Inactive",
  },
});
